 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_Cover'
 import HTML04_COPYRIGHT from '@/components/html/04_Copyright'
 import HTML03_TITLE_PAGE from '@/components/html/03_Title_Page'
 import HTML02_SERIES_PAGE from '@/components/html/02_Series_Page'
 import HTML05_DEDICATION from '@/components/html/05_Dedication'
 import HTML06_CONTENTS from '@/components/html/06_Contents'
 import HTML07_NEVER_A_CITY_SO_REAL from '@/components/html/07_Never_a_City_So_Real'
 import HTML08_OIL_CAN_EDDIE from '@/components/html/08_Oil_Can_Eddie'
 import HTML09_MILLIE_AND_BRENDA from '@/components/html/09_Millie_and_Brenda'
 import HTML10_GIVE_THEM_WHAT_THEY_WANT from '@/components/html/10_Give_Them_What_They_Want'
 import HTML11_26TH_STREET from '@/components/html/11_26th_Street'
 import HTML12_IT_TAKES_ALL_KINDS from '@/components/html/12_It_Takes_All_Kinds'
 import HTML13_INSIDE_OUT from '@/components/html/13_Inside_Out'
 import HTML14_GT_S_DINER from '@/components/html/14_GT_s_Diner'
 import HTML15_ISN_T_THAT_THE_CORNICHE from '@/components/html/15_Isn_t_That_the_Corniche'
 import HTML16_AFTERWORD from '@/components/html/16_Afterword'
 import HTML17_ACKNOWLEDGMENTS from '@/components/html/17_ACKNOWLEDGMENTS'
 import HTML18_ABOUT_THE_AUTHOR from '@/components/html/18_ABOUT_THE_AUTHOR'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/06_Contents",
 			"name" : "html/06_Contents",
 			"component" : HTML06_CONTENTS
 		},
 		{
 			"path" : "/html/07_Never_a_City_So_Real",
 			"name" : "html/07_Never_a_City_So_Real",
 			"component" : HTML07_NEVER_A_CITY_SO_REAL
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js